export const distritos = [
  "Miraflores",
  "Breña",
  "San Isidro",
  "Barranco",
  "La Molina",
  "Callao",
  "Cercado de Lima",
  "San Martin de Porres",
  "San Miguel",
];
export const horasPaseo = [1, 2, 3];

export const razas = [
  "Criollo",
  "Golden Retriever",
  "Bulldog",
  "Boxer",
  "Pit Bull",
  "Pug",
  "Beagle",
  "Pastor Alemán",
  "Doberman",
  "Rottweiler",
  "Cocker",
  "Dálmata",
  "Shar Pei",
  "Otro",
];
